"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const protocolPhases = [{
  label: "PHASE 01: INGESTION",
  description: "Continuous aggregation of market data, pattern recognition algorithms, and historical precedents to form a baseline."
}, {
  label: "PHASE 02: SYNTHESIS",
  description: "Structuring the noise into actionable slots. The AI Caddie evaluates probabilities without emotional bias."
}, {
  label: "PHASE 03: EXECUTION",
  description: "Presenting the structured plan. You retain full control of the final decision, armed with systematic clarity."
}];
export default function TheAiProtocol() {
  const {
    ref: sectionRef,
    isVisible: isSectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="the-ai-protocol" className="dark bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8" ref={sectionRef}>
      <div className={`max-w-6xl mx-auto bg-card p-6 lg:p-12 grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 transition-all duration-1000 ease-out ${isSectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        {}
        <div className="bg-background border-l-[3px] border-primary p-8 lg:p-12 flex flex-col justify-center relative overflow-hidden min-h-[300px]">
          {}
          <div className="absolute top-0 right-0 w-32 h-32 bg-primary/5 blur-3xl pointer-events-none"></div>
          
          <h2 className="font-serif text-[22px] leading-relaxed mb-8 text-foreground relative z-10">
            "The Caddie doesn't swing the club. It reads the wind, measures the distance, and hands you the right iron. The discipline to follow the read is yours."
          </h2>
          
          <p className="font-sans text-primary text-[11px] tracking-[0.2em] uppercase relative z-10">
            I CARRY THE DATA. YOU TAKE THE SHOT.
          </p>
        </div>

        {}
        <div className="flex flex-col gap-4 justify-center">
          {protocolPhases.map((phase, i) => <div key={i} data-index={i} className="bg-card border-l border-primary p-6 relative overflow-hidden group transition-colors duration-300 hover:bg-background/50">
              {}
              <div className="absolute inset-0 pointer-events-none opacity-[0.02] mix-blend-overlay" style={{
            backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 2px, var(--color-foreground) 2px, var(--color-foreground) 4px)'
          }} aria-hidden="true"></div>

              <h3 className="font-sans text-primary text-[9px] tracking-[0.15em] uppercase mb-3 relative z-10">
                {phase.label}
              </h3>
              
              <p className="font-serif text-[14px] text-foreground/65 leading-relaxed relative z-10">
                {phase.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}